var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9068 4.93071C13.618 4.17238 14.63 3.75 15.7501 3.75C20.9063 3.75 20.6219 12 15.7501 12C13.7211 12 12.0639 10.1272 11.9082 7.92796C11.8244 6.74499 12.1937 5.69105 12.9068 4.93071ZM15.7501 10.5C14.6947 10.5 13.5188 9.43642 13.4045 7.82195C13.3032 6.39378 14.3008 5.25 15.7501 5.25C17.1726 5.25 18.205 6.30861 18.0958 7.82111C17.9794 9.43679 16.8047 10.5 15.7501 10.5Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2074 18.5437C23.3928 19.2992 22.9233 20.2499 21.9296 20.2499H9.571C8.57973 20.2499 8.10442 19.3012 8.29386 18.541C9.97396 11.7961 21.5478 11.7733 23.2074 18.5437ZM21.7109 18.7499H9.79042C11.2345 13.6903 20.2841 13.6654 21.7109 18.7499Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.89061 5.25C4.9738 5.25 3.51521 6.74868 3.6581 8.76885C3.78631 10.5799 5.16819 12.1875 6.89061 12.1875C8.61378 12.1875 9.99273 10.5787 10.123 8.76984C10.2662 6.78291 8.81235 5.25 6.89061 5.25ZM6.89061 10.6875C4.72569 10.6875 4.49293 6.75 6.89061 6.75C9.28229 6.75 9.05589 10.6875 6.89061 10.6875Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96864 13.6617C8.35713 12.9234 6.33812 12.839 4.60056 13.3936C2.85264 13.9515 1.28733 15.1967 0.788663 17.1973L0.788406 17.1984C0.619782 17.879 1.04535 18.7498 1.95562 18.7498H7.21874C7.63295 18.7498 7.96874 18.414 7.96874 17.9998C7.96874 17.5856 7.63295 17.2498 7.21874 17.2498H2.3366C2.75328 16.0547 3.7678 15.2339 5.05664 14.8226C6.46452 14.3733 8.0961 14.4537 9.34384 15.0254C9.72041 15.1979 10.1655 15.0325 10.3381 14.656C10.5106 14.2794 10.3452 13.8343 9.96864 13.6617Z",
    fill: "#1C1C1C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.2a48bca15ea7edc03ea4c5f24c4fd1eb.svg";
export { ForwardRef as ReactComponent };